
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/partners-guide",
      function () {
        return require("private-next-pages/policy/partners-guide/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy/partners-guide"])
      });
    }
  